/**
 * eCommerce Quick Links Widget
 * Advanced search with fuzzy matching, auto-suggestions for products, pages, categories
 * Only loads if widget is present on page
 */

(function () {
    'use strict';

    window.cmQuickLinksData = window.cmQuickLinksData || {
        ajax_url: typeof cm_ajax !== 'undefined' ? cm_ajax.ajax_url : '/wp-admin/admin-ajax.php',
        nonce: typeof cm_ajax !== 'undefined' ? cm_ajax.nonce : '',
        search_limit: 8,
        root_url: window.location.origin,
        i18n: {
            noResults: 'Keine Ergebnisse gefunden',
            minChars: 'Tippen Sie mindestens 3 Zeichen um zu suchen',
            close: 'Schließen',
            search: 'Suche',
            cart: 'Warenkorb',
            account: 'Mein Konto',
            product: 'Produkt',
            page: 'Seite',
            category: 'Kategorie',
            oftenSearched: 'Oft Gesucht'
        }
    };

    const CMEcommerceQuickLinks = {
        searchInput: null,
        searchOverlay: null,
        searchResults: null,
        searchLoading: null,
        searchEmpty: null,
        searchHint: null,
        searchToggle: null,
        cartCount: null,
        searchTimeout: null,
        minChars: 3,
        i18n: window.cmQuickLinksData.i18n || {},

        init() {
            const hasWidget = document.querySelector('.cm-quick-links');
            if (!hasWidget) {
                return;
            }
            
            this.cacheElements();
            this.bindEvents();
            this.updateCartCount();

            document.addEventListener('added_to_cart', () => this.updateCartCount());
            document.addEventListener('removed_from_cart', () => this.updateCartCount());
            document.body.addEventListener('wc_cart_fragments_refreshed', () => this.updateCartCount());
        },

        cacheElements() {
            this.searchToggle = document.querySelector('.cm-search-toggle');
            this.searchOverlay = document.querySelector('.cm-search-overlay');
            this.searchInput = document.querySelector('.cm-search-input');
            this.searchResults = document.querySelector('.cm-search-results');
            this.searchLoading = document.querySelector('.cm-search-loading');
            this.searchEmpty = document.querySelector('.cm-search-empty');
            this.searchHint = document.querySelector('.cm-search-hint');
            this.searchPopular = document.querySelector('.cm-search-popular');
            this.searchPopularGrid = document.querySelector('.cm-search-popular-grid');
            this.searchPopularTitle = document.querySelector('.cm-search-popular-title');
            this.cartCount = document.querySelector('.cm-cart-count');
            
            // Off-canvas menu
            this.menuToggle = document.querySelector('.cm-menu-toggle');
            this.offcanvas = document.querySelector('.cm-offcanvas');
            this.offcanvasOverlay = document.querySelector('.cm-offcanvas-overlay');
            this.offcanvasClose = document.querySelector('.cm-offcanvas-close');
            
            if (this.searchOverlay && this.searchOverlay.dataset.i18n) {
                try {
                    const dataI18n = JSON.parse(this.searchOverlay.dataset.i18n);
                    this.i18n = { ...this.i18n, ...dataI18n };
                } catch (e) {}
            }
            
            if (this.searchHint && this.searchHint.querySelector('p') && this.i18n.minChars) {
                this.searchHint.querySelector('p').textContent = this.i18n.minChars;
            }
        },

        bindEvents() {
            if (this.searchToggle) {
                this.searchToggle.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.openSearch();
                });
            }

            if (this.searchOverlay) {
                this.searchOverlay.addEventListener('click', (e) => {
                    if (e.target === this.searchOverlay) {
                        this.closeSearch();
                    }
                });
            }

            // Off-canvas menu
            if (this.menuToggle) {
                this.menuToggle.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.toggleMenu();
                });
            }

            if (this.offcanvasClose) {
                this.offcanvasClose.addEventListener('click', () => this.closeMenu());
            }

            if (this.offcanvasOverlay) {
                this.offcanvasOverlay.addEventListener('click', () => this.closeMenu());
            }

            // Accordion sub-menus (delegated — off-canvas may not exist yet)
            document.addEventListener('click', (e) => {
                const toggle = e.target.closest('.cm-offcanvas-nav .menu-item-has-children > a');
                if (toggle) {
                    e.preventDefault();
                    toggle.closest('.menu-item-has-children').classList.toggle('is-open');
                }
            });

            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    if (this.searchOverlay && this.searchOverlay.classList.contains('cm-search-open')) {
                        this.closeSearch();
                    }
                    if (this.offcanvas && this.offcanvas.classList.contains('is-active')) {
                        this.closeMenu();
                    }
                }
            });

            const closeBtn = document.querySelector('.cm-search-close-btn');
            if (closeBtn) {
                closeBtn.addEventListener('click', () => this.closeSearch());
            }

            if (this.searchInput) {
                this.searchInput.addEventListener('input', (e) => this.handleSearch(e));
                this.searchInput.addEventListener('focus', () => {
                    if (this.searchInput.value.length >= this.minChars) {
                        this.performSearch(this.searchInput.value);
                    }
                });
                this.searchInput.addEventListener('keydown', (e) => this.handleKeyboard(e));
            }
        },

        openSearch() {
            if (!this.searchOverlay) return;
            this.searchOverlay.classList.add('cm-search-open');
            document.body.style.overflow = 'hidden';
            
            this.loadPopularItems();
            
            setTimeout(() => {
                if (this.searchInput) this.searchInput.focus();
            }, 100);
        },

        closeSearch() {
            if (!this.searchOverlay) return;
            this.searchOverlay.classList.remove('cm-search-open');
            document.body.style.overflow = '';
            if (this.searchInput) this.searchInput.value = '';
            this.clearResults();
            // Reset popular items visibility for next open
            if (this.searchPopular) {
                this.searchPopular.style.display = 'block';
            }
        },

        toggleMenu() {
            if (this.offcanvas && this.offcanvas.classList.contains('is-active')) {
                this.closeMenu();
            } else {
                this.openMenu();
            }
        },

        openMenu() {
            if (!this.offcanvas || !this.offcanvasOverlay) return;
            this.menuToggle.setAttribute('aria-expanded', 'true');
            this.offcanvas.classList.add('is-active');
            this.offcanvas.setAttribute('aria-hidden', 'false');
            this.offcanvasOverlay.classList.add('is-active');
            this.offcanvasOverlay.setAttribute('aria-hidden', 'false');
            document.body.classList.add('cm-offcanvas-open');
        },

        closeMenu() {
            if (!this.offcanvas || !this.offcanvasOverlay) return;
            this.menuToggle.setAttribute('aria-expanded', 'false');
            this.offcanvas.classList.remove('is-active');
            this.offcanvas.setAttribute('aria-hidden', 'true');
            this.offcanvasOverlay.classList.remove('is-active');
            this.offcanvasOverlay.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('cm-offcanvas-open');
        },

        async loadPopularItems() {
            if (!this.searchPopular || !this.searchPopularGrid) return;
            
            // Always reload when opening
            try {
                const ajaxUrl = window.cmQuickLinksData.ajax_url;
                const nonce = window.cmQuickLinksData.nonce;
                
                const response = await fetch(`${ajaxUrl}?action=cm_get_popular_items&limit=6&nonce=${nonce}`);
                const data = await response.json();
                
                if (data.success && data.data.items && data.data.items.length > 0) {
                    this.displayPopularItems(data.data.items);
                }
            } catch (error) {
                console.error('Error loading popular items:', error);
            }
        },

        displayPopularItems(items) {
            if (!this.searchPopular || !this.searchPopularGrid) return;
            
            this.searchPopular.style.display = 'block';
            
            if (this.searchPopularTitle && this.i18n.oftenSearched) {
                this.searchPopularTitle.textContent = this.i18n.oftenSearched;
            }
            
            this.searchPopularGrid.innerHTML = '';
            
            items.forEach((item, index) => {
                const div = document.createElement('a');
                div.className = 'cm-search-popular-item';
                div.href = item.permalink;
                div.style.animationDelay = `${index * 50}ms`;
                
                const imageHtml = item.image 
                    ? `<img src="${item.image}" alt="${this.escapeHtml(item.name)}">`
                    : `<span class="cm-no-image"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"></rect></svg></span>`;
                
                const priceHtml = item.price ? `<span class="cm-search-popular-price">${item.price} €</span>` : '';
                
                div.innerHTML = `
                    <div class="cm-search-popular-image">${imageHtml}</div>
                    <h5 class="cm-search-popular-name">${this.escapeHtml(item.name)}</h5>
                    ${priceHtml}
                `;
                
                this.searchPopularGrid.appendChild(div);
            });
        },

        handleSearch(e) {
            const query = e.target.value.trim();
            if (this.searchTimeout) clearTimeout(this.searchTimeout);
            
            if (query.length < this.minChars) {
                this.clearResults();
                return;
            }

            this.searchTimeout = setTimeout(() => {
                this.performSearch(query);
            }, 250);
        },

        async performSearch(query) {
            if (!this.searchResults || !this.searchLoading || !this.searchEmpty || !this.searchHint) return;

            this.searchResults.style.display = 'none';
            this.searchEmpty.style.display = 'none';
            this.searchHint.style.display = 'none';
            this.searchLoading.style.display = 'flex';

            try {
                const ajaxUrl = window.cmQuickLinksData.ajax_url;
                const nonce = window.cmQuickLinksData.nonce;
                const limit = window.cmQuickLinksData.search_limit || 8;
                
                const response = await fetch(`${ajaxUrl}?action=cm_ajax_search&s=${encodeURIComponent(query)}&limit=${limit}&nonce=${nonce}`);
                const data = await response.json();
                
                if (data.success) {
                    this.displayResults(data.data, query);
                } else {
                    this.showEmpty();
                }
            } catch (error) {
                console.error('Search error:', error);
                this.showEmpty();
            }
        },

        displayResults(results, query) {
            if (!this.searchResults || !this.searchLoading || !this.searchEmpty || !this.searchHint) return;

            this.searchLoading.style.display = 'none';
            
            if (this.searchPopular) {
                this.searchPopular.style.display = 'none';
            }

            const hasProducts = results.products?.length > 0;
            const hasPosts = results.posts?.length > 0;
            const hasPages = results.pages?.length > 0;
            const hasCategories = results.categories?.length > 0;

            if (!hasProducts && !hasPosts && !hasPages && !hasCategories) {
                this.showEmpty();
                return;
            }

            this.searchResults.innerHTML = '';
            this.searchResults.style.display = 'flex';

            let delay = 0;

            if (hasProducts) {
                results.products.forEach(product => {
                    const item = this.createResultItem(product, 'product', query);
                    item.style.animationDelay = `${delay}ms`;
                    this.searchResults.appendChild(item);
                    delay += 30;
                });
            }

            if (hasCategories) {
                results.categories.forEach(cat => {
                    const item = this.createCategoryItem(cat, query);
                    item.style.animationDelay = `${delay}ms`;
                    this.searchResults.appendChild(item);
                    delay += 30;
                });
            }

            if (hasPages) {
                results.pages.forEach(page => {
                    const item = this.createResultItem(page, 'page', query);
                    item.style.animationDelay = `${delay}ms`;
                    this.searchResults.appendChild(item);
                    delay += 30;
                });
            }

            if (hasPosts) {
                results.posts.slice(0, 3).forEach(post => {
                    const item = this.createResultItem(post, 'post', query);
                    item.style.animationDelay = `${delay}ms`;
                    this.searchResults.appendChild(item);
                    delay += 30;
                });
            }
        },

        createResultItem(item, type, query) {
            const a = document.createElement('a');
            a.className = 'cm-search-result';
            
            let url = '#';
            let title = item.name || item.title?.rendered || item.name;
            
            if (type === 'product') {
                url = item.permalink || `#product-${item.id}`;
            } else if (type === 'page') {
                url = item.link || `#page-${item.id}`;
            } else if (type === 'post') {
                url = item.link || `#post-${item.id}`;
            }
            
            a.href = url;
            
            let imageHtml = '';
            let priceHtml = '';
            
            if (type === 'product') {
                if (item.images && item.images.length > 0) {
                    imageHtml = `<div class="cm-search-result-image"><img src="${item.images[0].src}" alt="${this.escapeHtml(title)}"></div>`;
                } else {
                    imageHtml = `<div class="cm-search-result-image cm-no-image"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"></rect></svg></div>`;
                }
                priceHtml = item.price ? `<span class="cm-search-result-price">${item.price} €</span>` : '';
            }
            
            const typeLabels = {
                product: this.i18n.product || 'Produkt',
                page: this.i18n.page || 'Seite',
                post: 'Beitrag'
            };
            
            a.innerHTML = `
                ${imageHtml}
                <div class="cm-search-result-content">
                    <span class="cm-search-result-type">${typeLabels[type] || type}</span>
                    <h4 class="cm-search-result-title">${this.highlightMatch(title, query)}</h4>
                    ${priceHtml}
                </div>
            `;
            
            return a;
        },

        createCategoryItem(item, query) {
            const a = document.createElement('a');
            a.className = 'cm-search-result';
            a.href = item.link || `#category-${item.id}`;
            
            a.innerHTML = `
                <div class="cm-search-result-image cm-search-result-category-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                    </svg>
                </div>
                <div class="cm-search-result-content">
                    <span class="cm-search-result-type">${this.i18n.category || 'Kategorie'}</span>
                    <h4 class="cm-search-result-title">${this.highlightMatch(item.name, query)}</h4>
                    <span class="cm-search-result-count">${item.count || 0} Einträge</span>
                </div>
            `;
            
            return a;
        },

        highlightMatch(text, query) {
            if (!query) return this.escapeHtml(text);
            const escapedText = this.escapeHtml(text);
            const regex = new RegExp(`(${this.escapeRegex(query)})`, 'gi');
            return escapedText.replace(regex, '<span class="cm-search-highlight">$1</span>');
        },

        escapeHtml(text) {
            const div = document.createElement('div');
            div.textContent = text;
            return div.innerHTML;
        },

        escapeRegex(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        },

        clearResults() {
            if (this.searchResults) {
                this.searchResults.innerHTML = '';
                this.searchResults.style.display = 'none';
            }
            if (this.searchLoading) this.searchLoading.style.display = 'none';
            if (this.searchEmpty) this.searchEmpty.style.display = 'none';
            if (this.searchHint) this.searchHint.style.display = 'block';
            if (this.searchPopular) this.searchPopular.style.display = 'none';
        },

        showEmpty() {
            if (!this.searchResults || !this.searchLoading || !this.searchEmpty || !this.searchHint) return;
            this.searchLoading.style.display = 'none';
            this.searchResults.style.display = 'none';
            this.searchHint.style.display = 'none';
            const emptyMsg = this.searchEmpty.querySelector('p');
            if (emptyMsg && this.i18n.noResults) {
                emptyMsg.textContent = this.i18n.noResults;
            }
            this.searchEmpty.style.display = 'block';
        },

        handleKeyboard(e) {
            const results = document.querySelectorAll('.cm-search-result');
            if (!results.length) return;

            let activeIndex = -1;
            results.forEach((result, index) => {
                if (result === document.activeElement || result.contains(document.activeElement)) {
                    activeIndex = index;
                }
            });

            switch (e.key) {
                case 'ArrowDown':
                    e.preventDefault();
                    activeIndex = Math.min(activeIndex + 1, results.length - 1);
                    results[activeIndex].focus();
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    activeIndex = Math.max(activeIndex - 1, 0);
                    results[activeIndex].focus();
                    break;
                case 'Enter':
                    if (this.searchInput && this.searchInput.value.length >= this.minChars && activeIndex === -1) {
                        this.performSearch(this.searchInput.value);
                    }
                    break;
            }
        },

        updateCartCount() {
            if (!this.cartCount) return;

            if (typeof wc_cart_fragments_params !== 'undefined') {
                const fragmentKey = wc_cart_fragments_params.fragment_name;
                const storedFragment = sessionStorage.getItem(fragmentKey);

                if (storedFragment) {
                    try {
                        const fragment = JSON.parse(storedFragment);
                        const cartHash = fragment['div.widget_shopping_cart_content'];
                        if (cartHash) {
                            const tempDiv = document.createElement('div');
                            tempDiv.innerHTML = cartHash;
                            const countElement = tempDiv.querySelector('.count');
                            if (countElement) {
                                const count = countElement.textContent.replace(/[^0-9]/g, '');
                                this.setCartCount(count);
                                return;
                            }
                        }
                    } catch (e) {}
                }
            }

            this.fetchCartCount();
        },

        fetchCartCount() {
            const ajaxUrl = window.cmQuickLinksData.ajax_url;
            const nonce = window.cmQuickLinksData.nonce;

            fetch(`${ajaxUrl}?action=cm_get_cart_count&nonce=${nonce}`)
                .then(response => response.json())
                .then(data => {
                    if (data.success) this.setCartCount(data.data.count);
                })
                .catch(() => this.setCartCount(0));
        },

        setCartCount(count) {
            if (!this.cartCount) return;
            count = parseInt(count) || 0;
            if (count > 0) {
                this.cartCount.textContent = count > 9 ? '9+' : count;
                this.cartCount.classList.add('cm-has-items');
            } else {
                this.cartCount.textContent = '0';
                this.cartCount.classList.remove('cm-has-items');
            }
        }
    };

    document.addEventListener('DOMContentLoaded', () => CMEcommerceQuickLinks.init());
    window.elementorFrontend && window.elementorFrontend.on('document:loaded', () => CMEcommerceQuickLinks.init());

})();
